import { ErrorState, MetricCard, MetricGrid, Skeleton } from "@nymbl/nos2-rules";
import { type BalanceCard, type BalanceRow, balanceCards } from "@/lib/pto/balances";
import { round2 } from "@/lib/pto/days";

function Balance({ card }: { card: BalanceCard }) {
  return (
    <MetricCard
      label={card.label}
      value={String(card.left)}
      detail={card.pending > 0 ? `${round2(card.pending)} pending` : undefined}
      help={card.tooltip ?? undefined}
      alert={card.negative}
      alertLabel="Over"
      target={{ ratio: card.barPct / 100, label: `${card.left} of ${card.of}` }}
    />
  );
}

/** A card with no allowance and no usage would read 0 of 0 (UI standard 7): hide it. */
const hasContent = (c: BalanceCard) => c.of !== 0 || c.booked !== 0 || c.pending !== 0;

/** Vacation, Holidays, Sick (spec 1.2). Types with no allowance or usage get no card. */
export function BalanceCards({
  rows,
  isError,
  onRetry,
}: {
  rows: BalanceRow[] | undefined;
  isError: boolean;
  onRetry: () => void;
}) {
  if (isError) return <ErrorState message="Balances didn't load" onRetry={onRetry} />;
  if (!rows) return <Skeleton className="h-28 w-full" />;
  const cards = balanceCards(rows).filter(hasContent);
  if (cards.length === 0) return null;
  return (
    <MetricGrid>
      {cards.map((c) => (
        <Balance key={c.kind} card={c} />
      ))}
    </MetricGrid>
  );
}
